/* eslint-disable
    react/prop-types
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import * as biojs from 'BioJS';
import NoteConstants from 'notebook/notes/NoteConstants';
import PreviewMixin from 'notebook/notes/previews/PreviewMixin';
import React from 'react';
import createReactClass from 'create-react-class';
import * as sequtil from 'molbio/SeqUtil';

const {modelRangeToDisplay} = sequtil;

const SequencePrimerPreview = createReactClass({
  mixins: [PreviewMixin],

  className: 'note-primer',
  noteType: NoteConstants.SEQUENCE_PRIMER,

  renderItem() {
    const sequencePrimer = this.props.item;
    const [start, end] = modelRangeToDisplay(
      sequencePrimer.start,
      sequencePrimer.end,
      sequencePrimer.sequenceLength,
      sequencePrimer.sequenceStartIndex
    );
    const bindLength = sequencePrimer.bases.length - sequencePrimer.overhang_length;
    return (
      <div>
        <div className="note-preview-body">
          <div className="note-preview-drawing">
            <div className="location-start">{start}</div>
            <div
              className={classNames({
                'primer-render': true,
                reversed: sequencePrimer.strand === -1,
              })}
            >
              <div className="primer-body" style={{backgroundColor: sequencePrimer.color}} />
              <div className="primer-right-end" style={{borderLeftColor: sequencePrimer.color}} />
            </div>
            <div className="location-end">{end}</div>
          </div>
        </div>
        <dl className="dl-horizontal">
          <dt>Length</dt>
          <dd>{biojs.util.formatBaseCount(sequencePrimer.bases.length)}</dd>
          <dt>Binding Length</dt>
          <dd>{biojs.util.formatBaseCount(bindLength)}</dd>
          <dt>Overhang</dt>
          <dd>
            {sequencePrimer.overhang_length ? (
              sequencePrimer.bases.slice(0, sequencePrimer.overhang_length)
            ) : (
              <div className="faded">N/A</div>
            )}
          </dd>
        </dl>
      </div>
    );
  },
});

export default SequencePrimerPreview;
